var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2dff45e932baf496abad41f2e8c3f753623e29bb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@clio-ai"]={id:"2dff45e932baf496abad41f2e8c3f753623e29bb"};
      